<template>
  <div id="dashboard">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="10">
            <v-card>
              <v-card-title>
                <a class="breadcrums" @click="returnMenu">Productos</a>>
                {{ nombre }}
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-card>
                        <v-card-title>
                          Foto del Catálogo
                        </v-card-title>
                        <v-card-text align="center">
                          <img
                            v-if="fotoCatalogo"
                            :src="`${imgDir}galerias/productos/${fotoCatalogo}`"
                            alt=""
                            :width="imageSizeWidthCatalogo"
                            :height="imageSizeHeightCatalogo"
                          />
                          <p>Imagen (300 x 200 px)</p>
                          <foto-catalogo
                            :idProducto="idProducto"
                          ></foto-catalogo>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-card>
                        <v-card-title>
                          Foto Principal
                        </v-card-title>
                        <v-card-text align="center">
                          <img
                            v-if="fotoPrincipal"
                            :src="
                              `${imgDir}galerias/productos/${fotoPrincipal}`
                            "
                            alt=""
                            :width="imageSizeWidthCatalogo"
                            :height="imageSizeHeightCatalogo"
                          />
                          <p>Imagen (1280 x 600 px)</p>
                          <foto-principal
                            :idProducto="idProducto"
                          ></foto-principal>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-card>
                        <v-card-title>
                          Galería de Fotos
                        </v-card-title>
                        <v-card-text align="center">
                          <galeria-detalles :idProducto="idProducto" />
                          <foto-galeria :idProducto="idProducto"></foto-galeria>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-container>
                  <v-row>
                    <v-col cols="12" align="center">
                      <v-btn color="error" to="/admin/productos"
                        >Regresar</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const { useState } = createNamespacedHelpers("galerias");
import { imageService } from "@/services/imageService";
import FotoCatalogo from "@/components/FotoCatalogo.vue";
import FotoPrincipal from "@/components/FotoPrincipal.vue";
import GaleriaDetalles from "@/components/GaleriaDetalles.vue";
import FotoGaleria from "@/components/FotoGaleria.vue";

export default {
  name: "GaleriaProducto",
  components: {
    FotoCatalogo,
    FotoPrincipal,
    FotoGaleria,
    GaleriaDetalles
  },
  setup(props, { root }) {
    const title = ref("Galería");

    const {
      imgDir,
      imageSizeWidthCatalogo,
      imageSizeHeightCatalogo
    } = imageService(root);

    const idProducto = computed(() => parseInt(root.$route.params.id));

    const { nombre, fotoCatalogo, fotoPrincipal, fotos } = useState([
      "nombre",
      "fotoCatalogo",
      "fotoPrincipal",
      "fotos"
    ]);

    const init = () => {
      root.$store
        .dispatch("getProducto", idProducto.value)
        .then(response => {
          root.$store.commit("SET_PRODUCTO_NOMBRE", response.nombre_esp);
          root.$store.commit("SET_FOTO_CATALOGO", response.foto_cat);
          root.$store.commit("SET_FOTO_PRINCIPAL", response.foto_gal);
          root.item = response;
        })
        .catch(error => {
          console.log(error);
        });
    };

    const returnMenu = () => {
      root.$router.push(`/admin/productos`);
    };

    init();

    return {
      title,
      imgDir,
      idProducto,
      nombre,
      fotoCatalogo,
      fotoPrincipal,
      fotos,
      imageSizeWidthCatalogo,
      imageSizeHeightCatalogo,
      returnMenu
    };
  }
};
</script>

<style scoped>
a.breadcrums {
  margin-right: 5px;
}
</style>
